module.exports = __webpack_public_path__ + "static/media/scale.84953973.svg";